import { apiRequest, safeFormatDate } from 'helpers';
import {
  OrgReviewStatus,
  SummaryStats,
  TemporalDateRange,
  TemporalStatsReturn,
} from 'types';

export const fetchOrgReviewStatus = (orgArray: Array<number>) => {
  const params = new URLSearchParams();
  orgArray.forEach((orgId) => {
    params.append('organization_id', `${orgId}`);
  });
  return apiRequest<Array<OrgReviewStatus>>({
    method: 'GET',
    path: '/v3/stats/org_review_status',
    params: params,
  });
};

export const fetchSummaryStats = () =>
  apiRequest<SummaryStats>({
    method: 'GET',
    path: '/v3/stats/summary',
  });

export const fetchTemporalStats = (dateRange: TemporalDateRange) => {
  const { start_date, end_date } = dateRange;

  return apiRequest<TemporalStatsReturn>({
    method: 'GET',
    path: '/v3/stats/temporal',
    params: {
      start_date: safeFormatDate(start_date, 'yyyy-MM-dd'),
      end_date: safeFormatDate(end_date, 'yyyy-MM-dd'),
    },
  });
};

export const fetchTemporalBulkStats = (
  dateRanges: Array<TemporalDateRange>,
) => {
  const dateRangesStringified = dateRanges.map((dateRange) => ({
    start_date: safeFormatDate(dateRange.start_date, 'yyyy-MM-dd'),
    end_date: safeFormatDate(dateRange.end_date, 'yyyy-MM-dd'),
  }));
  return apiRequest<Array<TemporalStatsReturn>>({
    method: 'POST',
    path: '/v3/stats/temporal/bulk',
    data: dateRangesStringified,
  });
};
